import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            padding: 3,
            display: 'flex',
            flexDirection: 'column',
            gap:3,
            height: '100%',
        },
        mainContainer:{
            height: '100%',
        },
        flex1: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        containerFileData: {
            display: 'flex',
            mt: 2,
        },
        items: {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            gap: '10px',
            justifyContent: 'space-between',
            background: `${colors.color10}22`,
            position: 'relative',
            minHeight: '55px',
        },
        itemTitle: (isEdit:boolean) => ({
            width:  isEdit ? 'calc(100% - 135px)' : 'calc(100% - 90px)',
            wordBreak: 'break-word',
            display: '-webkit-box',
            WebkitLineClamp: 2, // Número de líneas antes de cortar
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            padding: '15px'
        }),
        iconContainer: (isEdit:boolean) => ({
            width: isEdit ? '120px' : '80px',
            display: 'flex',
            alignItems: 'center',
            '& .MuiButton-root': {
                '&.download': {
                    color: colors.color4,
                    minWidth: '25px',
                    padding: '0px 15px',
                    height: '100%'
                },
                '&.delete': {
                    color: colors.color19,
                    width: '25px',
                    height: '25px'
                },
                fontSize: '1.2rem',
                padding: '2px',
                '& .MuiSvgIcon-root': {
                    fontSize: '25px',
                },
            },
        }),
        progress: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            minHeight: '55px',
            top: 0,
            left: '0px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(5px)',
        },
    }
}

export { useStyles }
